<template>
    <div>
        <LoaderMaskComponent v-if="lyLoading"/>
        <div v-else>
            <breadcrumb-component
                :moduleTitle="'Service management'"
                :mainTitle="'SSH Terminal'"
                :subTitle="'SSH terminal'"
            />
            <div class="row">
                <div class="col-md-12">
                    <div class="card card_full_window vm_list_page ">
                        <div class="card-body">
                            <div class="common_content_wrap">
                                <div class="common_content_left">
                                    <ServiceLeftMenuComponent/>
                                </div>
                                <div class="common_content_right">
                                    <div class="row">
                                        <div class="col_12">
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" id="with_password" v-model="connection_type" @change="changeConnectionType('password')" value="password">
                                                <label class="form-check-label" for="with_password" >Password</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" id="without_password" @change="changeConnectionType('keychain')" v-model="connection_type" value="keychain">
                                                <label class="form-check-label" for="without_password" >Keychain</label>
                                            </div>
                                        </div>
                                        <div class="col_3">
                                            <div class="mb-3">
                                                <label for="host" class="col-form-label">Host</label>
                                                <input type="text" class="form-control" id="host" v-model="host">
                                                <div v-if="errors.host" class="error">{{ errors.host }}</div>
                                            </div>
                                        </div>
                                        <div class="col_3">
                                            <div class="mb-3">
                                                <label for="username" class="col-form-label">Username</label>
                                                <input type="text" class="form-control" id="username" v-model="username">
                                                <div v-if="errors.username" class="error">{{ errors.username }}</div>
                                            </div>
                                        </div>
                                        <div class="col_3" v-if="connection_type == 'password'">
                                            <div class="mb-3">
                                                <label for="password" class="col-form-label">Password</label>
                                                <input type="password" class="form-control" id="password" v-model="password">
                                                <div v-if="errors.password" class="error">{{ errors.password }}</div>
                                            </div>
                                        </div>
                                        <div class="col_3" v-if="connection_type == 'keychain'">
                                            <div class="mb-3">
                                                <label for="pem_file" class="col-form-label">Keychain</label>
                                                <input type="file" class="form-control" id="pem_file" @change="handleFileUpload">
                                                <div v-if="errors.pemKey" class="error">{{ errors.pemKey }}</div>
                                            </div>
                                        </div>
                                        <div class="col_3">
                                            <div class="mb-3">
                                                <label for="port" class="col-form-label">Port</label>
                                                <input type="number" class="form-control" id="port" v-model="port">
                                                <div v-if="errors.port" class="error">{{ errors.port }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col_12">
                                            <div class="mb-3">
                                                <div class="d_flex_start">
                                                    <button type="button" class="btn btn-primary btn-sm" @click="connectToServer">Connect</button>
                                                    <button type="button" class="btn btn-danger btn-sm ml_5" v-if="connected" @click="disconnect">Disconnect</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col_12">
                                            <div id="terminal" ref="terminal" style="width: 100%;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import ServiceLeftMenuComponent from "../ServiceLeftMenuComponent.vue";
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import { Terminal } from 'xterm';
import 'xterm/css/xterm.css';
import { io } from 'socket.io-client';
import {mapGetters} from "vuex";

export default {
    name: 'ssh-terminal',
    components: {
        LoaderMaskComponent,
        ServiceLeftMenuComponent,
        BreadcrumbComponent,
    },
    data() {
        return {
            lyLoading: false,
            socketUrl: process.env.VUE_APP_SOCKET_URL,
            connection_type: 'password',
            terminal: null,
            host: '',
            username: '',
            password: '',
            port: 22,
            pemKey: null,
            socket: null,
            connected: false,
            terminalInputDisposable: null,
            errors: {  
                host: '',
                username: '',
                password: '',
                pemKey: '',
                port: '',
            },
        };
    },
    computed: {
        ...mapGetters({
            customer: 'auth/getUserInfo',
        }),
    },
    mounted() {
        this.terminal = new Terminal();
        this.terminal.open(this.$refs.terminal);
    },
    methods: {
        changeConnectionType(type){
            if(type == 'password'){
                this.pemKey = ''
            }
            if(type == 'keychain'){
                this.password = ''
            }
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            const reader = new FileReader();
            
            reader.onload = () => {
                this.pemKey = reader.result;
            };
            
            reader.readAsText(file);
        },
        validateFields() {
            this.errors = {
                host: '',
                username: '',
                password: '',
                pemKey: '',
                port: '',
            };

            let isValid = true;

            if (!this.host) {
                this.errors.host = 'Host is required.';
                isValid = false;
            }

            if (!this.username) {
                this.errors.username = 'Username is required.';
                isValid = false;
            }
            if(this.connection_type == 'password' && !this.password){
                this.errors.password = 'Password is required.';
                isValid = false;
            }
            if(this.connection_type == 'keychain' && !this.pemKey){
                this.errors.pemKey = 'Keychain is required.';
                isValid = false;
            }

            if (!this.port) {
                this.errors.port = 'Port is required.';
                isValid = false;
            }

            if (this.password && this.pemKey) {
                this.errors.password = 'You can use either a password or a PEM file, but not both.';
                this.errors.pemKey = 'You can use either a password or a PEM file, but not both.';
                isValid = false;
            }

            return isValid;
        },
        connectToServer() {
            if (!this.validateFields()) {
                return;
            }

            if (this.socket) {
                this.disconnect();
            }

            this.socket = io(this.socketUrl +'/ssh');

            this.socket.on('connect', () => {
                const data = {
                    host: this.host,
                    username: this.username,
                    password: this.password,
                    pemKey: this.pemKey,
                    port: this.port,
                };

                this.socket.emit('connect_ssh', data);
                this.connected = true;

                if (this.terminalInputDisposable) {
                    this.terminalInputDisposable.dispose();
                }

                this.terminalInputDisposable = this.terminal.onData((input) => {
                    if (this.socket && this.socket.connected) {
                        this.socket.emit('terminal_input', input);
                    }
                });
            });

            this.socket.on('ssh_data', (data) => {
                this.terminal.write(data);
            });

            this.socket.on('ssh_closed', (message) => {
                this.terminal.write(`\r\n${message}\r\n`);
                this.disconnect();
            });

            this.socket.on('ssh_error', (error) => {
                console.error(`SSH Error: ${error}`);
                this.terminal.write(`\r\nSSH Error: ${error}\r\n`);
                this.disconnect(); 
            });
        },
        disconnect() {
            if (this.socket) {
                this.socket.disconnect();
                this.socket = null;
            }

            if (this.terminalInputDisposable) {
                this.terminalInputDisposable.dispose();
                this.terminalInputDisposable = null;
            }

            this.connected = false;
            this.terminal.clear();
        },
    },
};
</script>
<style scoped>
    .error {
        color: red;
        font-size: 0.875rem;
        margin-top: 4px;
    }
</style>
